import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usuarios-categoria',
  templateUrl: './usuarios-categoria.component.html',
  styleUrls: ['./usuarios-categoria.component.css']
})
export class UsuarioCategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
